import { useState, MouseEvent, useEffect } from "react";
import { GetDataFilesDataFileGetParams, GetDatasetsDatasetGetParams, GetJobsJobsGetParams, GetModelFamiliesModelFamilyGetParams, GetReadacrossReadacrossGetParams, GetResultsetsResultsetGetParams, GetSinglePredictionResultsetsResultsetSinglePredictionGetParams, User } from "../api/models";
import { useGetUsersUsersGet } from "../api/generated/fastAPI";
import { FilterBarType } from "../components/Filtering/FilterBar";

export type GetParamsTypes = (
    GetDataFilesDataFileGetParams 
    | GetDatasetsDatasetGetParams 
    | GetModelFamiliesModelFamilyGetParams
    | GetResultsetsResultsetGetParams
    | GetSinglePredictionResultsetsResultsetSinglePredictionGetParams
)


const useDataParams = ({
    defaultParams,
    defaultFilters,
    tagsData,
}: {
    defaultParams: GetParamsTypes | GetReadacrossReadacrossGetParams | GetJobsJobsGetParams,
    defaultFilters?: FilterBarType[],
    tagsData?: { [key: string]: string[] },
}) => {
    const [ params, setParams ] = useState<GetParamsTypes | GetReadacrossReadacrossGetParams | GetJobsJobsGetParams>(defaultParams);
    const [ filters, setFilters ] = useState<FilterBarType[]>([]);
    const getUsersMutation = useGetUsersUsersGet();
    

    useEffect(() => {
        let usernames: string[] = [];
        let tags: string[] = [];

        if (getUsersMutation.data) {
            const users = getUsersMutation.data as unknown as User[];
            if (users.length > 0) {
                users.forEach(user => usernames.push(user.username));
            }
        }

        if (tagsData) {
            Object.keys(tagsData).forEach(tagDataKey => {
                const associatedTags = tagsData[tagDataKey];
                associatedTags.forEach(tag => {
                    tags.push(tagDataKey === 'general' ? tag : `${tagDataKey}::${tag}`)
                })
            })
            // tags = tagsData 
        }

        if (defaultFilters) {
            const filtersWithOptions = defaultFilters.map(filter => {
                if (filter.type === 'tags') {
                    return {...filter, options: tags}
                } else if (filter.type === 'users') {
                    return {...filter, options: usernames}
                } else {
                    return {...filter}
                }
            })
    
            setFilters(filtersWithOptions);
        }

        

    }, [getUsersMutation.data, tagsData, defaultFilters]);

    const search = (key: string, value: string) => {
        
        setParams({
            ...params,
            [key]: value,
        })
    };

    const sort = (e: MouseEvent<HTMLButtonElement>, value: string) => {
        e.preventDefault();

        const sortBy = params.sort_by;
        const sortOrder = params.sort_order;

        if (sortBy !== undefined && sortOrder !== undefined) {
            let updatedSortOrder: 'asc' | 'desc' | null = null;

            const updatedSortBy = value as 'name' | 'created_by' | 'owner' | 'creation_date' | 'updated_date' | 'smiles' | 'readacross_type' | 'start_date' | 'end_date' | 'execution_date' | 'queued_at';

            if (sortBy === value) {
                if (sortOrder === 'asc') {
                    updatedSortOrder = 'desc'
                } else {
                    updatedSortOrder = 'asc'
                }
            } else {
                updatedSortOrder = 'desc';
            }

            setParams({
                ...params,
                sort_by: updatedSortBy,
                sort_order: updatedSortOrder,
            })
        }

    }

    const setPaginationLimit = (limit: number) => {
        setParams({
            ...params,
            limit,
            offset: 0,
        })
    }

    const setPaginationOffset = (pageNumber: number) => {
        const limit = params.limit;

        if (limit) {
            setParams({
                ...params,
                offset: limit * pageNumber,
            })
        }
    }


    return {
        params,
        setParams,
        search,
        sort,
        filters,
        setPaginationLimit,
        setPaginationOffset,
    }
};

export default useDataParams;